<div class="area-form">

    <!-- area name input -->
    <tk-area-form-input [control]="form.controls['Nm']" [newAreaNamePlaceHolder]="newAreaNamePlaceHolder"
        [areaType]="form.controls['Tp'].value"></tk-area-form-input>

    <!-- area thickness -->
    <div *ngIf="form.controls['Tp'].value === AreaTypeEnum.Line" class="area-form__thickness">
        <span class="area-form__thickness-label">{{'map.width' | translate}}</span>
        <div class="area-form__range">
            <span class="area-form__range-btn" (click)="subThickness()">
                <i class="fas fa-caret-left"></i>
            </span>
            <span class="area-form__range-label">
                {{ form.controls['Th'].value }} {{'measure-unit.meter-short' | translate}}
            </span>
            <span class="area-form__range-btn" (click)="addThickness()">
                <i class="fas fa-caret-right"></i>
            </span>
        </div>
    </div>

    <!-- area tags -->
    <div class="area-form__tag-picker">
        <tk-tag-picker [tagType]="2" (onSelectedTags)="handleOnSelectedTags($event)"
            [selectedTags]="form.controls['Tg'].value"></tk-tag-picker>
    </div>


    <div class="area-form__action-container">

        <!-- save button -->
        <emq-button styleClass="area-form__save"
            [ngStyleClass]="{'area-form__save--inactive': isSavingEnabled !== true}"
            [disabled]="false" (onClick)="save()">
          {{'labels.save' | translate | titlecase}}
        </emq-button>

        <!-- delete button -->
        <tk-area-delete *ngIf="area && area.Id" [area]="area" (onDelete)="onDeleteDone()"></tk-area-delete>
    </div>

</div>
